<template>
  <div class="hornor-buy-level-nav" ref="hornorBuyLevelNav">
    <van-tabs
      ref="nav"
      class="level-nav"
      v-model="current"
      :style="{ minHeight: clientHeight + 'px' }"
      :sticky="true"
      :offset-top="navHeight"
      :ellipsis="false"
      :border="false"
      :title-active-color="navTab.fontColor"
      :title-inactive-color="navTab.fontColor"
      :lazy-render="true"
      @change="switchTab"
    >
      <van-tab
        class="tab-item"
        title-style="padding: 0 0.25rem"
        v-for="(tabName, index) in navList"
        :title="tabName.title"
        :key="index"
      >
        <div class="container">
          <div class="product-lists" v-show="index === current">
            <div class="tab-content" v-show="contList.length">
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
              >
                <div class="title">
                  <img src="../../assets/img/hornor-buy/gift-icon.png" alt="" />
                  0元购
                </div>
                <div class="product-list">
                  <level-item
                    :sku-list="contList"
                    :column="column"
                  ></level-item>
                </div>
                <div class="title">
                  <img
                    src="../../assets/img/hornor-buy/cat-price-icon.png"
                    alt=""
                  />
                  直降{{level}}
                </div>
                <div class="product-list">
                  <level-item
                    :sku-list="catPriceList"
                    :column="column"
                  ></level-item>
                </div>
              </van-list>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs, List } from 'vant'
import LevelItem from './hornorBuyLevelItem'
// let flag = false
let timer = null
export default {
  name: 'hornorBuyLevelNav',
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    VanList: List,
    LevelItem
  },
  props: {
    navList: {
      type: Array
    },
    navHeight: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      navTab: {
        lineColor: '#C83753',
        fontColor: '#404040'
      },
      clientHeight: 0,
      current: 0,
      loading: false,
      finished: true,
      contList: [],
      catPriceList: []
    }
  },
  computed: {
    column () {
      return this.navList.length && this.navList[this.current].id
    },
    level () {
      return this.navList.length && this.navList[this.current].subtitle
    }
  },
  watch: {
    current (newVal) {
      this.contList = []
      this.catPriceList = []
      this.finished = true
      this.pageNum = 1
      clearTimeout(timer)
      timer = setTimeout(() => {
        this.getContList(this.column)
        this.getCatPriceList(this.column)
      }, 150)
    }
  },
  mounted () {
    this.clientHeight = document.documentElement.clientHeight
  },
  methods: {
    /**
     * 分页加载
     */
    onLoad () {
      // if (flag) {
      //   return
      // }
      // flag = true
      // setTimeout(() => {
      //   this.getContList(this.navList[this.current].id).then(
      //     () => {
      //       this.loading = false
      //       flag = false
      //     }
      //   )
      // }, 150)
    },

    /**
     * 导航切换
     */
    switchTab (i) {
      this.$toast.loading('正在加载...')
    },

    /**
     * '获取商品列表
     */
    async getContList (id) {
      const data = await this.getGoodsListHandler(id, 0)
      if (data.length) {
        this.contList = data
      }
    },

    /**
     * 获取直降330列表
     */
    async getCatPriceList (id) {
      const data = await this.getGoodsListHandler(id, 1)
      if (data.length) {
        this.catPriceList = data
      }
    },

    /**
     *获取列表封装
     */
    async getGoodsListHandler (id, catid) {
      const res = await this.$axios.get(`api/business/goods/${id}/${catid}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          return data
        } else if (code === 9006) {
          this.finished = true
        } else {
          this.finished = true
          this.$toast(msg)
        }
      }
    }

  }
}
</script>
<style lang="less">
.level-nav {
  .van-tabs__wrap {
    padding: 0 0.1rem !important;
    background-color: #fff;
  }
  .vant-tab,
  .van-tab--active {
    font-size: 0.26rem !important;
    font-weight: bold !important;
  }
}
</style>
<style lang="less" scoped>
.container {
  padding: 0 0.2rem;
  .title {
    position: relative;
    font-size: @fz32;
    color: @base;
    text-align: center;
    margin: 0.4rem 0;
    &::after,
    &::before {
      content: "";
      position: absolute;
      width: 1.2rem;
      height: 1px;
      background-color: #d2d2d2;
      top: 50%;
      transform: translateY(-50%);
    }
    &::before {
      left: 1rem;
    }
    &::after {
      right: 1rem;
    }
    img {
      width: 0.38rem;
      height: 0.39rem;
      padding-right: 0.14rem;
    }
  }
}
</style>
